import selectric from "./jquery.selectric.js";

export default function initForms() {

  // VALIDATION START -----------------------------------------------------------
  // VALIDATION START -----------------------------------------------------------
  // VALIDATION START -----------------------------------------------------------
 
  //Validating form on submit
  (function () {
    'use strict';

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName('needs-validation');
      // Loop over them and prevent submission
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener('submit', function (event) {
          // Check if all fields are valid then submit
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            errorMessages($(this));
            // Validate Selectric
            $("select").closest('.c-dropdown-selectric').removeClass('dropdown-invalid');
            $(this).find("select:invalid").closest('.c-dropdown-selectric').addClass('dropdown-invalid');
            $(this).find('.fieldset').removeClass('fieldset-invalid');
            $(this).find(".form-control:invalid").closest('.fieldset').addClass('fieldset-invalid');
            $(this).addClass('invalid');
            $(this).find('.fieldset-invalid').each(function () {
              // console.log($(this).data("fieldset-name"));
              $(this).closest('form').find('.fieldset-error-message--'+$(this).data("fieldset-name")).addClass('show');
            });
          } else {
            errorMessages($(this));
            event.preventDefault();
            $(this).removeClass('invalid');
            replaceActionValue($(this));
            submitForm(event,  $(this));
          }
          form.classList.add('was-validated');
        }, false);
      });
   
  })();

  //Validating fields on change
  (function () {
    'use strict';
      // fetch all the forms we want to apply custom style
      var inputs = document.getElementsByClassName('form-control')

      // loop over each input and watch blue event
      var validation = Array.prototype.filter.call(inputs, function (input) {

        input.addEventListener('blur', function (event) {
          var form = $(this).closest('form');
          if(form.hasClass('was-validated')){
            errorMessages($(this));
            // reset
            input.classList.remove('is-invalid')
            input.classList.remove('is-valid')

            if (input.checkValidity() === false) {
              input.classList.add('is-invalid')
            } else {
              input.classList.add('is-valid')
            }
          }
        }, false);

        input.addEventListener('input', function (event) {
          var form = $(this).closest('form');
          form.find('.fieldset').removeClass('fieldset-invalid');
          form.find(".form-control:invalid").closest('.fieldset').addClass('fieldset-invalid');
        }, false);
      });
  
  })()

  // Move data-action attribute value into action attribute for spam protection
  function replaceActionValue(thisObj) {
    var dataAttr = thisObj.data();
    if((dataAttr.action !== "") && (dataAttr.action !== undefined)) {
      thisObj.get(0).setAttribute('action', dataAttr.action);
    }
  }

  // Validate Selectric
  $("select").change(function () {
    $(this).closest('.c-dropdown-selectric').removeClass('dropdown-invalid');
    errorMessages($(this));
  });

  $("input").on("change", function() {
    var form = $(this).closest('form');
    errorMessages(form);
  });

  // Select the radio button if there's only one option and set the corresponding token value
  var $fieldset = $('.fieldset.radio-buttons');
  if ($fieldset.hasClass('single-option')) {
    var token = "";
    token = $fieldset.find("input[name='NexudusId']").data("revinate-list-id");
    $fieldset.closest('form').find("input[name='tokens']").val(token);
    $fieldset.hide();
  }

  // Populate revinate tokens field
  $("input[name='NexudusId']").change(function(){
    var token = "";
      token = $(this).data("revinate-list-id");
      $(this).closest('form').find("input[name='tokens']").val(token);
  });

  function errorMessages(thisObj) {
    setTimeout(function () {
      var form = thisObj.closest('form');
      var error_messages_container = form.find('.error-messages .invalid-feedback');
      error_messages_container.html('');
      if(form.find('.form-control ~ .invalid-feedback:visible, .dropdown-invalid .invalid-feedback:visible').length > 0){
        error_messages_container.prepend('Form errors:');
        form.find('.form-control ~ .invalid-feedback:visible, .dropdown-invalid .invalid-feedback:visible').each(function () {
          var invalid_text = $(this).text();
          var invalid_html = ` <br aria-hidden="true">${ invalid_text } ` ;
          error_messages_container.append(invalid_html);
        });
      }
      if(form.hasClass('was-validated')){
        form.find('.fieldset').removeClass('fieldset-invalid');
        form.find(".form-control:invalid").closest('.fieldset').addClass('fieldset-invalid');
        if(!form.find('.form-control ~ .invalid-feedback:visible, .dropdown-invalid .invalid-feedback:visible').length){
          form.removeClass('invalid');
        } else {
          form.addClass('invalid');
        }
      }
    }, 10);
  }


  // VALIDATION END -----------------------------------------------------------
  // VALIDATION END -----------------------------------------------------------
  // VALIDATION END -----------------------------------------------------------

  function submitForm(event, thisObj) {
    event.preventDefault();
    var form = thisObj;
    var action = thisObj.attr("action");
    var thanksEl = thisObj.next('.form-thanks');
    var formDataSerialized = $(form).serialize();
    var formDataArray = $(form).serializeArray();

    // Build Revinate API payload
    var contact = {};

    for (var i = 0; i < formDataArray.length; i++) {
      var formField = formDataArray[i];
      contact[formField.name] = formField.value;
      if(formField.name === 'tokens'){
        var tokenString = formField.value;
        var token = tokenString.split(";");
      }
    }
    var data = {tokens: token, contacts: []};
    data.contacts = [contact];

    function submitRevinate(callback) {
      console.log(JSON.stringify(data));
      if(form.find("input[name='SignUpToNewsletter']").length > 0 && form.find("input[name='SignUpToNewsletter']:checked").length < 1) {
        console.log('opt-out');
        callback();
      } else {
        console.log('opt-in or sign-up');
        $.ajax({
          type: "POST",
          url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
          contentType: "application/json",
          crossDomain: true,
          dataType: "json",
          data: JSON.stringify(data),
        })
        .done(function (result) {
          callback();
        })
        .fail(function (XMLHttpRequest, textStatus, errorThrown) {
          // Throw error if CRM API fails
          showError(
            "Request: " +
            XMLHttpRequest.toString() +
            "\n\nStatus: " +
            textStatus +
            "\n\nError: " +
            errorThrown
          );
        });
      }
    }

    function submitNexudus() {
      console.log("nexuduss");
      // return form.submit();
      // Otherwise post using AJAX and display Thanks element when complete
      $.post(action, formDataSerialized)
        .done(function (result) {
          console.log(1212);
          // callback();
        })
        .fail(function (XMLHttpRequest, textStatus, errorThrown) {

          console.log(8888);
          // Throw error if Wordpress Submit fails
          showError(
            "Request: " +
            XMLHttpRequest.toString() +
            "\n\nStatus: " +
            textStatus +
            "\n\nError: " +
            errorThrown
          );
        });
    }

    function showThanks() {
      $(form).closest('.cb-sign-up-form').find('.cb-sign-up-form__text').hide();
      $(form).closest('.modal-enquiry-form__container').find('.modal-enquiry-form__container__top .c-wysiwyg').hide();
      $(form).hide();
      $(thanksEl).show();
      $(form).next('.form-thanks:visible').get(0).scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    function showError(message) {
      $(form).find("input, select, button").prop("disabled", false);
      alert(message);
    }

    // Submit to Revinate then Nexudus
    submitRevinate(function () {
      submitNexudus();
    });
    showThanks();
  }

  $(document).ready(function() {
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
          callback.call(thisArg, this[i], i, this);
        }
      };
    }
  
    const FloatLabel = (() => {
      // add active class and placeholder
      const handleFocus = e => {
        const target = e.target;
        if(target.previousElementSibling){
          if(target.previousElementSibling.getAttribute("for") == "time" || target.previousElementSibling.getAttribute("for") == "date") {
            target.previousElementSibling.textContent = "";
          } else {
            target.parentNode.classList.add("active");
          }
        } else {
          target.parentNode.classList.add("active");
        }
        target.setAttribute("placeholder", target.getAttribute("data-placeholder"));
  
      };
  
      // remove active class and placeholder
      const handleBlur = e => {
        const target = e.target;
        if ((!target.value) && (target.type != "date") && (target.type != "time")) {
          target.parentNode.classList.remove("active");
        }
        target.removeAttribute("placeholder");
      };
  
      // register events
      const bindEvents = element => {
        const floatField = element.querySelector("input" + ",textarea");
        floatField.addEventListener("focusin", handleFocus);
        floatField.addEventListener("blur", handleBlur);
      };
  
      // get DOM elements
      const init = () => {
        const floatContainers = document.querySelectorAll(".form__trigger");
  
        floatContainers.forEach(element => {
          if (element.querySelector("input" + ",textarea").value) {
            element.classList.toggle("active");
          }
  
          bindEvents(element);
        });
      };
  
      return {
        init: init
      };
    })();
  
    FloatLabel.init();
  
  })
}
